import React from 'react';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const UnreadCountMsg = styled('span')({
  backgroundColor: 'red',
  color: '#fff',
  width: 24,
  height: 24,
  borderRadius: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '12px'
});

const ChatProfile = ({ chatProfile, onProfileClick, activeId }) => {
  const t = useAutoTranslation();

  const { conversationId, receiver = null, unreadMessageCount } = chatProfile;

  return (
    <>
      <List>
        <ListItemButton
          selected={conversationId === activeId}
          onClick={() => onProfileClick(chatProfile)}
          clickable={false}
        >
          <ListItemText primary={receiver || t('GENERAL')}></ListItemText>
          {!!unreadMessageCount && conversationId !== activeId && (
            <UnreadCountMsg>{unreadMessageCount}</UnreadCountMsg>
          )}
        </ListItemButton>
      </List>
      <Divider />
    </>
  );
};

export default ChatProfile;
